import { Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Specials({ specials = [], centered = false }) {
  if (!specials.length) return null;
  return (
    <Reveal className={centered ? "mx-auto w-full max-w-2xl" : "w-full"}>
      <div
        data-testid="hero-specials"
        className="h-full bg-background border-2 border-foreground rounded-3xl shadow-brutal-lg p-7 md:p-9 text-center"
      >
        <p className="overline text-secondary inline-flex items-center justify-center gap-2 mb-5">
          <Sparkles size={15} /> Specials &amp; Events
        </p>
        <ul className="space-y-3.5">
          {specials.map((s, i) => (
            <li
              key={i}
              data-testid={`special-item-${i}`}
              className="flex items-center justify-center gap-3 text-lg md:text-xl font-semibold leading-snug"
            >
              <span className="w-2 h-2 rounded-full bg-secondary shrink-0" />
              <span>{s}</span>
            </li>
          ))}
        </ul>
      </div>
    </Reveal>
  );
}
